import { S3_SHARED_BUCKET_URL as e } from "../../constants/s3-bucket-url.mjs";
import { fontWeights as s } from "../constants/font-weights.mjs";
const g = (o, t) => {
  const f = [];
  return s[o].forEach((n) => {
    f.push(r({ fontFamily: o, fontWeight: n }));
  }), s[t].forEach((n) => {
    f.push(r({ fontFamily: t, fontWeight: n }));
  }), f.join(`
`);
}, r = ({
  fontFamily: o,
  fontWeight: t
}) => `@font-face {
  font-family: '${o}';
  font-style: normal;
  font-weight: ${t};
  font-display: swap;
  src: url('${e}/fonts/google-fonts/${o}/${a(
  t
)}.woff2') format('woff2');
  }
  `, a = (o) => o === 400 ? "regular" : o, m = ({
  fontFamily: o
}) => `@font-face {
  font-family: '${o}';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('${e}/fonts/google-fonts/${o}/preview/preview.woff2') format('woff2');
  }
  `;
export {
  g as getFontCss,
  r as getSingleFontCssString,
  m as getSingleFontPreviewCssString
};
